module.exports = __webpack_public_path__ + "img/logo.5c604a97.png";